import React from "react";
import PropTypes from "prop-types";

import Str from "shared/components/Str";
import allowMobileMode from "shared/util/allowMobileMode";
import getMobileType from "shared/util/getMobileType";
import isRouteMatch from "shared/util/isRouteMatch";
import { ROUTES, ROUTE_LIST } from "routers/shared/util/consts";
import {
	APPLE_LINK,
	ANDROID_LINK,
} from "shared/dictionaries/app_store_campaigns.js";
import FOOTER_LINK from "shared/constants/footerLink";

// Routes to hide the footer on.
export const NO_FOOTER_ROUTES = [
	...ROUTES.AccountReactivate,
	...ROUTES.Logout,
	...ROUTES.Offboarding,
	...ROUTES.Onboarding,
	...ROUTES.PhoneWall,
	...ROUTES.Signup,
	...ROUTES.Splash,
	...ROUTES.StandaloneConversation,
];

export const NO_CTA_ROUTES = [
	...ROUTES.Upgrade,
	...ROUTES.Incognito,
];

const FOOTER_LINKS = [
	FOOTER_LINK.Apps,
	FOOTER_LINK.Press,
	FOOTER_LINK.AdChoices,
	FOOTER_LINK.About,
	FOOTER_LINK.Careers,
	FOOTER_LINK.Support,
	FOOTER_LINK.Blog,
	FOOTER_LINK.TechBlog,
	FOOTER_LINK.Privacy,
	FOOTER_LINK.Cookies,
	FOOTER_LINK.Terms,
	FOOTER_LINK.Safety,
	FOOTER_LINK.CommunityGuidelines,
	FOOTER_LINK.Security,
];

const Footer = ({ location }) => {
	const is404 = !isRouteMatch(location, ROUTE_LIST);
	const showFooter = !is404 && !isRouteMatch(location, NO_FOOTER_ROUTES);
	const showCTA = !is404 && !isRouteMatch(location, NO_CTA_ROUTES);

	if (!showFooter) {
		return null;
	}

	// some small overrides
	const wrapperStyle = { "background": "#104da1" };
	const copyrightStyle = { "float": "none" };
	const showMobileSiteLink = !!getMobileType();

	return (
		<div className="footer-wrapper" style={wrapperStyle}>
			{showCTA && (
				<div id="footer-cta-container">
					<div className="footer-cta">
						<div className="phone-cartoon" />
						<div className="app-copy">
							<h4 className="download-it">
								<Str>Download the OkCupid app</Str>
							</h4>
							<p className="discover-people">
								<Str>
									Discover people on the go (or when you’re too lazy to get your laptop out).
								</Str>
							</p>
						</div>
						<div className="app-links">
							<a href={ANDROID_LINK("footer_cta")} className="google store">google play</a>
							<a href={APPLE_LINK("footer_cta")} className="apple store">app store</a>
						</div>
					</div>
				</div>
			)}
			<footer className="page-section">
				<div id="footer" className="container_16 clearfix footer callout">

					<div className="footer-social">
						<a className="footer-social-circle facebook" target="_blank" rel="noopener noreferrer" href="https://facebook.com/okcupid">
							<i className="okicon i-facebook" />
						</a>
						<a className="footer-social-circle twitter" target="_blank" rel="noopener noreferrer" href="https://twitter.com/okcupid">
							<i className="okicon i-twitter" />
						</a>
						<a className="footer-social-circle instagram" target="_blank" rel="noopener noreferrer" href="https://instagram.com/okcupid">
							<i className="okicon i-instagram" />
						</a>
					</div>

					<ul id="footer_nav" className="footer-nav">
						{FOOTER_LINKS.map((link) => (
							<li key={link.href} className="footer-nav-link">
								<a href={link.href} target="_blank" rel="noopener noreferrer">
									{link.name}
								</a>
							</li>
						))}
						{showMobileSiteLink && (
							<li className="footer-nav-link">
								<button className="button" onClick={() => allowMobileMode(true)}>
									<Str>Switch to Mobile Site</Str>
								</button>
							</li>
						)}
					</ul>

					<div className="footer-copyright" style={copyrightStyle}>
						© OkCupid {new Date().getFullYear()}
					</div>
				</div>
			</footer>
		</div>
	);
};

Footer.propTypes = {
	location: PropTypes.object.isRequired,
};

export default Footer;



// WEBPACK FOOTER //
// ./src/routers/Desktop/Footer.jsx